"use client";
import { IntercomProvider } from "react-use-intercom";

export default function IntercomComponent() {
    const appId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID || "";

    if (!appId) {
        return null;
    }

    return (
        <IntercomProvider appId={appId} autoBoot={true}>
        </IntercomProvider>
    );
}